<template lang="html">
  <div class="div">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.div {
}
</style>



// WEBPACK FOOTER //
// src/parts/layout/div.vue